"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const DocumentIcon = createSVGIcon(
  <>
    <path
      d="M7.5 1.25H0.75V14.75H11.25V5M7.5 1.25L9.375 3.125L11.25 5M7.5 1.25V5H11.25"
      stroke="currentColor"
    />
  </>,
  "Document",
  { viewBox: "0 0 23 17", fill: "none" }
);
